import { useState, useEffect, useCallback } from "react";
import useAuth from "./useAuth";
import { STOCKITEMS_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  timeAttendances: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const useTimeAttendanceListFetch = (startDate, endDate) => {
  const auth = useAuth();
  const [timeAttendancestate, setState] = useState(initialState);
  const [timeAttendancesearchValue, timeAttendancesetSearchValue] = useState("");
  const [includeInactive, timeAttendancesetIncludeInactive] = useState(false);
  const [timeAttendanceloading, timeAttendancesetLoading] = useState(false);
  const [timeAttendanceerror, setError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  const accessToken = auth.auth.accessToken;

  const fetchTimeAttendanceList = useCallback(
    async (page, searchValue, reset = false) => {
      if (!hasMore && !reset) return;

      try {
        timeAttendancesetLoading(true);
        setError(false);

        console.warn("startdate for fetch = " +startDate)
        console.warn("enddate for fetch = " +endDate)
        console.log("Fetching attendance (reset:", reset, ")");
        const data = await API.fetchTimeAttendanceList(
          searchValue,
          page,
          includeInactive,
          accessToken,
          startDate,
          endDate
        );

        console.log("Fetched data:", data);

        setState((prev) => ({
          ...prev,
          timeAttendances: reset ? data.timeAttendances : data.timeAttendances,
          page: page + 1,
          total_pages: data.total_pages,
          total_results: data.total_results,
        }));

        setHasMore(data.timeAttendances.length > 0);
        timeAttendancesetLoading(false);
      } catch (error) {
        console.error("Error fetching time attendance:", error);
        setError(true);
      }
    },
    [startDate, endDate, includeInactive, accessToken, hasMore]
  );

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchTimeAttendanceList(1, timeAttendancesearchValue, true);
    }
  }, [firstLoad, fetchTimeAttendanceList]);

  useEffect(() => {
    fetchTimeAttendanceList(1, timeAttendancesearchValue, true);
  }, [timeAttendancesearchValue, includeInactive, startDate, endDate, fetchTimeAttendanceList]);

  return {
    timeAttendancestate,
    timeAttendanceloading,
    timeAttendanceerror,
    timeAttendancesearchValue,
    timeAttendancesetLoading,
    timeAttendancesetSearchValue,
    timeAttendancesetIncludeInactive,
    fetchTimeAttendanceList,
  };
};
